<div *ngIf="listingData" class="mct-gap-27 mct-grid-gt-sm mct-cols-1-1-gt-sm">
  <div class="mct-col-1-span-2-gt-sm">
    <h4>
      {{ 'form-builder.legos.listing.field-settings' | translate | ucfirst }}
    </h4>
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
      <p-checkbox
        name="DisplayCategory"
        [(ngModel)]="listingData.DisplayCategory"
        [binary]="true"
        [disabled]="true"
        inputId="displayCategory"
      >
      </p-checkbox>
      <label for="displayCategory">
        {{ 'form-builder.legos.listing.listing-category' | translate | ucfirst }}
      </label>
    </div>
    <input name="CategoryLabel" class="form-control" type="text" [(ngModel)]="listingData.CategoryLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
      <p-checkbox name="DisplaySubCategory" [(ngModel)]="listingData.DisplaySubCategory" [binary]="true" inputId="displaySubCategory">
      </p-checkbox>
      <label for="displaySubCategory">
        {{ 'form-builder.legos.listing.listing-subcategory' | translate | ucfirst }}
      </label>
    </div>
    <input name="SubCategoryLabel" class="form-control" type="text" [(ngModel)]="listingData.SubCategoryLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
      <p-checkbox
        name="DisplayLongDescription"
        [(ngModel)]="listingData.DisplayLongDescription"
        [binary]="true"
        inputId="displayLongDescription"
      >
      </p-checkbox>
      <label for="displayLongDescription">
        {{ 'form-builder.legos.listing.long-description' | translate | ucfirst }}
      </label>
    </div>
    <input name="LongDescriptionLabel" class="form-control" type="text" [(ngModel)]="listingData.LongDescriptionLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
      <p-checkbox
        name="DisplayShortDescription"
        [(ngModel)]="listingData.DisplayShortDescription"
        [binary]="true"
        inputId="displayShortDescription"
      >
      </p-checkbox>
      <label for="displayShortDescription">
        {{ 'form-builder.legos.listing.short-description' | translate | ucfirst }}
      </label>
    </div>
    <input name="ShortDescriptionLabel" class="form-control" type="text" [(ngModel)]="listingData.ShortDescriptionLabel" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <div class="mct-flex mct-justify-start mct-items-center mct-gap-4">
      <p-checkbox name="DisplayKeywords" [(ngModel)]="listingData.DisplayKeywords" [binary]="true" inputId="displayKeywords"> </p-checkbox>
      <label for="displayKeywords">
        {{ 'form-builder.legos.listing.keywords' | translate | ucfirst }}
      </label>
    </div>
    <input name="KeywordsLabel" class="form-control" type="text" [(ngModel)]="listingData.KeywordsLabel" />
  </div>
  <div class="mct-col-1-span-2-gt-sm mt-16">
    <h4>{{ 'form-builder.legos.listing.additional-settings' | translate | ucfirst }}</h4>
  </div>
  <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-16">
    <p-checkbox name="Required" [(ngModel)]="listingData.Required" [binary]="true" inputId="listingRequired"> </p-checkbox>
    <label for="listingRequired">
      {{ 'common.required' | translate | ucfirst }}
    </label>
  </div>
  <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-16">
    <p-checkbox name="AllowAdditional" [(ngModel)]="listingData.AllowAdditional" [binary]="true" inputId="allowAdditional"> </p-checkbox>
    <label for="allowAdditional">
      {{ 'form-builder.legos.listing.allow-additional-listings' | translate | ucfirst }}
    </label>
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <label>{{ 'form-builder.legos.listing.price-per-addition' | translate | ucfirst }}</label>
    <input name="PricePerAdditional" class="form-control" type="number" [(ngModel)]="listingData.PricePerAdditional" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <label>{{ 'form-builder.legos.listing.revenue-item' | translate | ucfirst }}</label>
    <p-select
      [placeholder]="'form-builder.legos.purchase-item.select-a-revenue-item' | translate | ucfirst"
      name="AdditionalRevItemNum"
      [options]="revenueItemOptions"
      [(ngModel)]="listingData.AdditionalRevItemNum"
      appendTo="body"
      [style]="{ width: '100%' }"
      (onChange)="revenueItemChanged()"
      [required]="listingData.PricePerAdditional ? true : false"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-gap-5 mt-16">
    <label>
      {{ 'form-builder.legos.listing.limit-additional' | translate | ucfirst }}
    </label>
    <input name="AdditionalLimit" class="form-control" type="number" [(ngModel)]="listingData.AdditionalLimit" />
  </div>
</div>
